var _path, _path2, _g, _path3, _g2, _path4, _path5, _g3, _path6, _path7, _g4, _path8, _path9, _g5, _path0, _path1, _g6, _path10, _path11, _path12, _g7, _path13, _g8, _path14, _path15, _g9, _path16, _path17, _g0, _path18, _path19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkPikko(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 59,
    viewBox: "0 0 35 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.69
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.99801 14.0711C2.99801 14.0711 15.2807 13.247 15.3643 26.1793C2.15788 26.0972 2.99801 14.0711 2.99801 14.0711Z",
    fill: "#5C5A5A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11117_13550",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 13,
    width: 15,
    height: 14
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.23926 13.0293H16.3504V26.9946H2.23926V13.0293Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11117_13550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0818 26.8887L15.3595 26.885C11.0999 26.857 7.78694 25.6283 5.51174 23.2268C1.94974 19.4698 2.27097 14.2491 2.28617 14.0291L2.32799 13.4231L2.94953 13.3802C2.94953 13.3802 3.1244 13.3672 3.43232 13.3672C5.53075 13.3672 15.9982 13.9862 16.078 26.1802L16.0818 26.8887Z",
    fill: "#5C5A5A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11117_13550",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 11,
    height: 20
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.457 0.320312H22.6755V19.7095H12.457V0.320312Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11117_13550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6263 19.4641L17.1188 18.9607C14.1252 15.9924 12.6711 12.8283 12.7965 9.55607C12.9923 4.43237 16.9877 0.964362 17.1588 0.820794L17.6263 0.419922L18.0958 0.820794C18.2669 0.964362 22.2623 4.43237 22.458 9.55607C22.5835 12.8283 21.1294 15.9924 18.1357 18.9607L17.6263 19.4641Z",
    fill: "#5C5A5A"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6026 14.0711C32.6026 14.0711 20.3219 13.247 20.2363 26.1793C33.4446 26.0972 32.6026 14.0711 32.6026 14.0711Z",
    fill: "#5C5A5A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_11117_13550",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 13,
    width: 15,
    height: 14
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2695 13.0293H33.3807V26.9946H19.2695V13.0293Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_11117_13550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5186 26.8887L19.5243 26.1802C19.6041 13.9862 30.0715 13.3672 32.168 13.3672C32.4779 13.3672 32.6527 13.3802 32.6527 13.3802L33.2724 13.4231L33.3161 14.0291C33.3313 14.2491 33.6525 19.4679 30.0905 23.2268C27.8172 25.6283 24.5023 26.857 20.2408 26.885L19.5186 26.8887Z",
    fill: "#5C5A5A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_11117_13550",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 20,
    width: 34,
    height: 39
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.2627 20.9668H34.351V58.3206H1.2627V20.9668Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_11117_13550)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_11117_13550",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 20,
    width: 34,
    height: 39
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7435 58.3236V20.9996C23.6314 20.9922 23.5212 20.9922 23.409 20.9922H12.2174V58.3236H23.7435ZM9.34917 58.3236H12.2174V20.9996H12.1547C7.51684 20.9996 3.44544 24.7119 3.11091 29.2446L1.54279 50.088C1.19875 54.6113 4.71324 58.3236 9.34917 58.3236ZM26.2126 58.3236C30.8505 58.3236 34.363 54.6113 34.0209 50.0787L32.4509 29.2371C32.1164 24.8145 28.2293 21.173 23.7359 20.9996V58.3236H26.2126Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_11117_13550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.0448 58.3245H1.54199V20.9707H34.0448V58.3245Z",
    fill: "#5C5A5A"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_11117_13550",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 20,
    width: 16,
    height: 15
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.785156 20.0234H15.5996V34.5555H0.785156V20.0234Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_11117_13550)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_11117_13550",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 20,
    width: 16,
    height: 15
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.19238 20.0273C4.10197 20.0273 0.785156 23.2791 0.785156 27.2934C0.785156 31.3058 4.10197 34.5594 8.19238 34.5594C12.2828 34.5594 15.5996 31.3058 15.5996 27.2934C15.5996 23.2791 12.2828 20.0273 8.19238 20.0273Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_11117_13550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.785156 20.0273H15.5996V34.5594H0.785156V20.0273Z",
    fill: "#5C5A5A"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_11117_13550",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 22,
    width: 10,
    height: 10
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5791 22.748H12.8167V31.8115H3.5791V22.748Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_11117_13550)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_11117_13550",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 22,
    width: 10,
    height: 10
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M8.19988 22.748C5.64907 22.748 3.58105 24.7766 3.58105 27.2807C3.58105 29.7829 5.64907 31.8115 8.19988 31.8115C10.7507 31.8115 12.8187 29.7829 12.8187 27.2807C12.8187 24.7766 10.7507 22.748 8.19988 22.748Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_11117_13550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.58105 22.748H12.8187V31.8115H3.58105V22.748Z",
    fill: "#5C5A5A"
  })))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.76899 28.472C9.76899 27.3814 10.5979 26.5953 11.6854 26.5953C10.6484 26.5953 9.76987 25.7578 9.76987 24.7177C9.76987 25.7479 8.95 26.5953 7.85254 26.5953C8.95 26.5953 9.76899 27.421 9.76899 28.472Z",
    fill: "#5C5A5A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.76899 24.7168L9.76987 24.7177M9.76987 24.7177C9.76987 25.7578 10.6484 26.5953 11.6854 26.5953C10.5979 26.5953 9.76899 27.3814 9.76899 28.472C9.76899 27.421 8.95 26.5953 7.85254 26.5953C8.95 26.5953 9.76987 25.7479 9.76987 24.7177Z",
    stroke: "#5C5A5A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_11117_13550",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 39,
    width: 12,
    height: 10
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6055 39.0234H23.0862V48.1444H12.6055V39.0234Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_11117_13550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.845 50.5332C17.501 50.5332 17.1607 50.4967 16.8243 50.4224C16.486 50.3495 16.1591 50.2402 15.8416 50.0959C15.5242 49.9502 15.222 49.7738 14.9369 49.564C14.6499 49.3541 14.3857 49.115 14.1424 48.8483C13.8991 48.5802 13.6824 48.2901 13.4923 47.9753C13.3003 47.6619 13.1388 47.3296 13.0076 46.9798C12.8765 46.6315 12.7776 46.2715 12.7092 45.9013C12.6427 45.5296 12.6104 45.1565 12.6104 44.7776C12.6104 44.4001 12.6427 44.0255 12.7092 43.6553C12.7776 43.2851 12.8765 42.9251 13.0076 42.5753C13.1388 42.227 13.3003 41.8947 13.4923 41.5813C13.6824 41.2665 13.8991 40.9765 14.1424 40.7083C14.3857 40.4416 14.6499 40.2025 14.9369 39.9927C15.222 39.7828 15.5242 39.6064 15.8416 39.4607C16.1591 39.3164 16.486 39.2071 16.8243 39.1342C17.1607 39.0599 17.501 39.0234 17.845 39.0234C18.1891 39.0234 18.5293 39.0599 18.8657 39.1342C19.2041 39.2071 19.531 39.3164 19.8484 39.4607C20.1658 39.6064 20.4681 39.7828 20.7532 39.9927C21.0402 40.2025 21.3044 40.4416 21.5477 40.7083C21.791 40.9765 22.0077 41.2665 22.1977 41.5813C22.3897 41.8947 22.5513 42.227 22.6824 42.5753C22.8136 42.9251 22.9124 43.2851 22.9808 43.6553C23.0474 44.0255 23.0797 44.4001 23.0797 44.7776C23.0797 45.1565 23.0474 45.5296 22.9808 45.9013C22.9124 46.2715 22.8136 46.6315 22.6824 46.9798C22.5513 47.3296 22.3897 47.6619 22.1977 47.9753C22.0077 48.2901 21.791 48.5802 21.5477 48.8483C21.3044 49.115 21.0402 49.3541 20.7532 49.564C20.4681 49.7738 20.1658 49.9502 19.8484 50.0959C19.531 50.2402 19.2041 50.3495 18.8657 50.4224C18.5293 50.4967 18.1891 50.5332 17.845 50.5332Z",
    fill: "#5C5A5A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_11117_13550",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 44,
    width: 10,
    height: 7
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2031 44.2383H22.2659V50.628H13.2031V44.2383Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_11117_13550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3382 47.4311C22.3382 47.588 22.3078 47.7435 22.2507 47.899C22.1918 48.0531 22.1063 48.203 21.9922 48.3487C21.8782 48.4944 21.7394 48.6317 21.5741 48.7634C21.4087 48.8937 21.2205 49.0156 21.0095 49.1262C20.8005 49.2383 20.5705 49.3378 20.3234 49.4246C20.0763 49.5129 19.8159 49.5857 19.5403 49.646C19.2647 49.7062 18.9814 49.7525 18.6906 49.7833C18.3979 49.8141 18.1033 49.8295 17.8068 49.8295C17.5084 49.8295 17.2137 49.8141 16.9229 49.7833C16.6302 49.7525 16.347 49.7062 16.0714 49.646C15.7977 49.5857 15.5354 49.5129 15.2883 49.4246C15.0412 49.3378 14.8112 49.2383 14.6021 49.1262C14.3911 49.0156 14.203 48.8937 14.0376 48.7634C13.8722 48.6317 13.7335 48.4944 13.6194 48.3487C13.5054 48.203 13.4198 48.0531 13.3609 47.899C13.3039 47.7435 13.2754 47.588 13.2754 47.4311C13.2754 47.2728 13.3039 47.1173 13.3609 46.9618C13.4198 46.8077 13.5054 46.6578 13.6194 46.5121C13.7335 46.3664 13.8722 46.2291 14.0376 46.0974C14.203 45.9671 14.3911 45.8452 14.6021 45.7345C14.8112 45.6225 15.0412 45.523 15.2883 45.4361C15.5354 45.3479 15.7977 45.275 16.0714 45.2148C16.347 45.1545 16.6302 45.1083 16.9229 45.0775C17.2137 45.0467 17.5084 45.0312 17.8068 45.0312C18.1033 45.0312 18.3979 45.0467 18.6906 45.0775C18.9814 45.1083 19.2647 45.1545 19.5403 45.2148C19.8159 45.275 20.0763 45.3479 20.3234 45.4361C20.5705 45.523 20.8005 45.6225 21.0095 45.7345C21.2205 45.8452 21.4087 45.9671 21.5741 46.0974C21.7394 46.2291 21.8782 46.3664 21.9922 46.5121C22.1063 46.6578 22.1918 46.8077 22.2507 46.9618C22.3078 47.1173 22.3382 47.2728 22.3382 47.4311Z",
    fill: "#5C5A5A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_11117_13550",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 20,
    width: 16,
    height: 15
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9717 20.0391H34.7861V34.5711H19.9717V20.0391Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_11117_13550)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_11117_13550",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 20,
    width: 16,
    height: 15
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3809 20.043C23.2885 20.043 19.9736 23.2947 19.9736 27.309C19.9736 31.3215 23.2885 34.575 27.3809 34.575C31.4713 34.575 34.7881 31.3215 34.7881 27.309C34.7881 23.2947 31.4713 20.043 27.3809 20.043Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_11117_13550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9736 20.043H34.7881V34.575H19.9736V20.043Z",
    fill: "#5C5A5A"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_11117_13550",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 22,
    width: 10,
    height: 10
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7529 22.7637H31.9925V31.8271H22.7529V22.7637Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_11117_13550)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask14_11117_13550",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 22,
    width: 10,
    height: 10
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3717 22.7637C24.819 22.7637 22.751 24.7923 22.751 27.2963C22.751 29.7985 24.819 31.8271 27.3717 31.8271C29.9225 31.8271 31.9905 29.7985 31.9905 27.2963C31.9905 24.7923 29.9225 22.7637 27.3717 22.7637Z",
    fill: "white"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_11117_13550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.751 22.7637H31.9905V31.8271H22.751V22.7637Z",
    fill: "#5C5A5A"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9008 28.472C28.9008 27.3814 29.7297 26.5953 30.8173 26.5953C29.7802 26.5953 28.9017 25.7578 28.9017 24.7177C28.9017 25.7479 28.0818 26.5953 26.9844 26.5953C28.0818 26.5953 28.9008 27.421 28.9008 28.472Z",
    fill: "#5C5A5A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9008 24.7168L28.9017 24.7177M28.9017 24.7177C28.9017 25.7578 29.7802 26.5953 30.8173 26.5953C29.7297 26.5953 28.9008 27.3814 28.9008 28.472C28.9008 27.421 28.0818 26.5953 26.9844 26.5953C28.0818 26.5953 28.9017 25.7479 28.9017 24.7177Z",
    stroke: "#5C5A5A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkPikko);
export default __webpack_public_path__ + "static/media/darkPikko.91473b045dde05f5a6101ba118f0ba4e.svg";
export { ForwardRef as ReactComponent };